import React, { useEffect } from 'react';
import useAppContext from './utilities/use-app-context';
import MainHeader from './app-header/MainHeader';
import SubHeader from './app-header/SubHeader';
import MainFooter from './app-footer/MainFooter';
import ErrorMessage from './ErrorMessage';
import './style.css';

function NotFound(msg: any) {
  const { currentUser } = useAppContext();

  useEffect(() => {
    document.title = 'ATTOM Cloud - Error';
  }, []);

  if (currentUser) {
    return <>
      <MainHeader />
      <ErrorMessage message={msg} />
      <MainFooter />
    </>
  }
  return <>
    <SubHeader />
    <ErrorMessage message={msg} />
    <MainFooter />
  </>
}

export default NotFound;
